import { type Dispatch, type RefObject, type SetStateAction } from 'react';
import { mynazcaRouteCopy, mynazcaT } from '../apps/mynazca/mynazcaRouteCopy';
import { type ImagePathOptions, type ImagePathResult } from '../apps/mynazca/mynazcaWorkers';
import { MyNazcaMobileStepLayout } from './MyNazcaMobileStepLayout';
import { MyNazcaRouteOptionsFields } from './MyNazcaRouteOptionsFields';

type MyNazcaMobileStep2EditorProps = {
  lang: 'ja' | 'en';
  busy: string | null;
  stepBarRef: RefObject<HTMLElement | null>;
  imagePathResult: ImagePathResult | null;
  pathPreviewCanvasRef: RefObject<HTMLCanvasElement | null>;
  options: ImagePathOptions;
  setOptions: Dispatch<SetStateAction<ImagePathOptions>>;
  loadSavedOptionsForMode: (mode: 'strokeTrace' | 'density') => ImagePathOptions;
  onCreatePathPreview: () => void;
  workingBlob: Blob | null;
  canGoNext: boolean;
  onBack: () => void;
  onNext: () => void;
};

export function MyNazcaMobileStep2Editor({
  lang,
  busy,
  stepBarRef,
  imagePathResult,
  pathPreviewCanvasRef,
  options,
  setOptions,
  loadSavedOptionsForMode,
  onCreatePathPreview,
  workingBlob,
  canGoNext,
  onBack,
  onNext,
}: MyNazcaMobileStep2EditorProps) {
  return (
    <MyNazcaMobileStepLayout
      lang={lang}
      stepBarRef={stepBarRef}
      preview={(
        <div className="mynazca-app__section mynazca-app__section--path-preview mynazca-app__section--mobile-dock">
          {imagePathResult == null && (
            <p className="mynazca-app__mobile-preview-empty">
              {mynazcaT(mynazcaRouteCopy.previewEmpty, lang)}
            </p>
          )}
          <canvas
            ref={pathPreviewCanvasRef}
            className="mynazca-app__path-canvas mynazca-app__path-canvas--mobile-dock"
            style={imagePathResult == null ? { opacity: 0 } : undefined}
          />
        </div>
      )}
    >
      <div className="mynazca-app__section mynazca-app__mobile-step-section">
        <h2 className="mynazca-app__section-title">
          {mynazcaT(mynazcaRouteCopy.sectionTitle, lang)}
        </h2>
        <p className="mynazca-app__muted mynazca-app__muted--compact">
          {mynazcaT(mynazcaRouteCopy.sectionHint, lang)}
        </p>

        <MyNazcaRouteOptionsFields
          lang={lang}
          busy={busy}
          workingBlob={workingBlob}
          options={options}
          setOptions={setOptions}
          loadSavedOptionsForMode={loadSavedOptionsForMode}
          onCreatePathPreview={onCreatePathPreview}
        />

        <div className="mynazca-app__nav mynazca-app__nav--mobile-sticky">
          <button type="button" onClick={() => onBack()} disabled={busy != null}>
            {lang === 'ja' ? '← 戻る' : '← Back'}
          </button>
          <button type="button" className="mynazca-app__btn-primary" onClick={() => onNext()} disabled={!canGoNext || busy != null}>
            {lang === 'ja' ? '次へ →' : 'Next →'}
          </button>
        </div>
      </div>
    </MyNazcaMobileStepLayout>
  );
}
